import React, { useState, useEffect, useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { Container, Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import {fetchReviews} from "../../../actions/review_actions";
import { stars2 } from "../../../util/rating_util";

import { googleReviewUrl } from '../../../util/google_review_url';

const TestimonialsComponent2 = (props) => {

  const [maxReviews, setMaxReviews] = useState(window.innerWidth <= 1000 ? 4 : (props.reviews.length || 6));
  const [expandedReviews, setExpandedReviews] = useState(new Set());
  const [overflowingReviews, setOverflowingReviews] = useState(new Set());
  const contentRefs = useRef([]);

  useEffect(() => {
    const newOverflowing = new Set();
    contentRefs.current.forEach((el, index) => {
      if (el && el.scrollHeight > el.clientHeight) {
        newOverflowing.add(index);
      }
    });
    setOverflowingReviews(newOverflowing);
  }, [props.reviews, maxReviews]);

  const toggleReview = (id) => {
    setExpandedReviews(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  useEffect(() => {
    if (props.reviews.length === 0) {
      props.fetchReviews()
    } else if (window.innerWidth > 1000) {
      setMaxReviews(props.reviews.length);
    }
  }, [props.reviews]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1000) {
        setMaxReviews(4);
      } else if (props.reviews.length > 0) {
        setMaxReviews(props.reviews.length);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [props.reviews]);

  const review_divs = props.reviews.slice(0, maxReviews).map((review, index) => {

    const star_rating = stars2(review.rating);
    const differenceInDays = 10000;

    return (
      <div className="modernAnglesReview" key={index}>
        <div>
          <div>{star_rating}</div>
          <div
            ref={el => contentRefs.current[index] = el}
            className={`modernAnglesReviewContent${expandedReviews.has(index) ? ' expanded' : ''}`}
          >
            {review.content}
          </div>
          {(overflowingReviews.has(index) || expandedReviews.has(index)) && (
            <span className="modernAnglesReviewToggle" onClick={() => toggleReview(index)}>
              {expandedReviews.has(index) ? 'Show less' : 'Read more'}
            </span>
          )}
        </div>
        <div className="modernAnglesReviewAuthorSection">
          <div className="modernAnglesReviewAvatarAndName">
            <img className="modernAnglesReviewAvatar" src={review.author_avatar} />
            <div className="modernAnglesReviewAuthorName">{review.author_name}</div>
          </div>
          <div className="modernAnglesReviewTimeAndGoogle">
            <div className="modernAnglesReviewTime">
              {differenceInDays > 30 ? review.relative_time : `${differenceInDays} days ago`}
            </div>
            <div className="modernAnglesReviewGoogleSymbol">Google</div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className="modernAnglesReviewContainer" id={
      props.needsMarginBottom ? "modernAnglesReviewMarginBottom" :
      props.needsMarginTopAndBottom ? "modernAnglesReviewMarginBottomAndTop" :
      props.bookPage ? "modernAnglesReviewBookPage" : ""
    }>
      <div className="modernAnglesReviewGroup">
        {props.reviews.length > 0 ? review_divs : null}
      </div>
      {props.reviews.length > 0 && (
        <a href={googleReviewUrl} target="_blank" className="viewAllButton">
          View all
        </a>
      )}
    </div>
  );
};

const msp = (state) => ({
  reviews: state.entities.reviews
});

const mdp = (dispatch) => ({
  fetchReviews: () => dispatch(fetchReviews())
});

export default withRouter(connect(msp, mdp)(TestimonialsComponent2));